// SPDX-FileCopyrightText: 2022 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { hashMultiBallot, hashBallot512, decodeAuditableBallot, decodeAuditableMultiBallot, getLayoutProperties, getPoints, generateSampleAuditableBallot, checkIsBlank, } from "@sequentech/ui-core";
export var provideBallotService = function () { return ({
    hashMultiBallot: hashMultiBallot,
    hashBallot512: hashBallot512,
    decodeAuditableBallot: decodeAuditableBallot,
    decodeAuditableMultiBallot: decodeAuditableMultiBallot,
    getLayoutProperties: getLayoutProperties,
    getPoints: getPoints,
    generateSampleAuditableBallot: generateSampleAuditableBallot,
    checkIsBlank: checkIsBlank,
}); };
